$(function(){

	const body 				= $('body');
	const header 			= $('.site-header');
	const footer 			= $('.site-footer');
	const tablet_breakpoint = 990;
	const mobile_breakpoint = 750;

	function getParameterByName( name ) {
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( window.location.href );
      if( results == null )
        return "";
      else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function setMenuOffset(){
        var windowHeight = $(window).height();
    	var abarHeight = $('.announcement-bar').outerHeight();
        var headerHeight = $('.site-header-flex').outerHeight();
        var menuDrawerHeight = $('.menu-drawer').height( windowHeight - abarHeight - headerHeight );
        console.log('abarHeight', abarHeight);
        console.log('headerHeight', headerHeight);
        console.log('menuDrawerHeight', windowHeight - abarHeight - headerHeight);
    }

    // setHeaderOffset();
    
    if ($(window).width() < tablet_breakpoint) {

	    // Toggle mobile menu drawer
	    $(document).on('click', '.j-toggle-mobile-menu', function(e){
	    	e.preventDefault();
	    	setMenuOffset();
	    	body.toggleClass('mobile-menu-visible');
	    });

	    // Show mobile menu child list
	    $(document).on('click', '.j-show-child-list', function(e){
	    	e.preventDefault();
	    	$('.site-header .menu-drawer .menu-drawer-inner .drawer-footer').hide();
	    	$(this).parent().find('.submenu').addClass('expand');
	    });

	    // Hide mobile menu child list
	    $(document).on('click', '.j-hide-child-list', function(e){
	    	e.preventDefault();
	    	$('.site-header .menu-drawer .menu-drawer-inner .drawer-footer').show();
	    	$('.submenu').removeClass('expand');
	    });

	    // Footer nav block toggle (mobile)
	    $(document).on('click', '.j-toggle-footer-block', function(e){
	    	e.preventDefault();
	    	$(this).toggleClass('active').parent().find('.block-detail').slideToggle();
	    });

	}

    // Toggle search modal (mobile)
    $(document).on('click', '.j-toggle-search', function(e){
    	e.preventDefault();
    	var bodyShunt = $('.site-header').height();
    	body.toggleClass('search-expanded');
    	$('.site-header .site-header-flex .search-widget').css('top', bodyShunt);
    	$('.site-header .site-header-flex .search-widget').slideToggle();

    	if ( body.hasClass('mobile-menu-visible') ){
    		if ($(window).width() < tablet_breakpoint) {
    			$('.j-toggle-mobile-menu').trigger('click');
    		}
    	}
    });

    $(document).on('click', '.j-toggle-cart', function(e){

        e.preventDefault();
        console.log($('#rebuy-cart').length);
        if ( $('#rebuy-cart').length > 0 ){
        	window.Rebuy.SmartCart.show();
        } else {
        	$('.cart-modal').fadeToggle();
        	body.toggleClass('cart-expanded');
        }

    });

    $(document).on('click', '.boost-pfs-filter-bottom-pagination .pagination__item.link', function(){
    	$("html, body").animate({
			scrollTop: $('.collection-filters').offset().top
		}, 500);
        setTimeout(function(){
            $('.meta-mh').matchHeight({ property: 'min-height' });
        }, 1000); 
    });

    // Currency selector script

    function currencyFormSubmit(event) {
		event.target.form.submit();
	}

	document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
		element.addEventListener('change', currencyFormSubmit);
	});

    $(document).on('click', '.j-currency-selector', function(e){

    	e.preventDefault();
    	$(this).toggleClass('active').parent().find('.disclosure').slideToggle();

    });

	class LocalizationForm extends HTMLElement {
	  constructor() {
	    super();
	    this.elements = {
	      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
	      button: this.querySelector('button'),
	      panel: this.querySelector('ul'),
	    };
	    this.elements.button.addEventListener('click', this.openSelector.bind(this));
	    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
	    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

	    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
	  }

	  hidePanel() {
	    this.elements.button.setAttribute('aria-expanded', 'false');
	    this.elements.panel.setAttribute('hidden', true);
	  }

	  onContainerKeyUp(event) {
	    if (event.code.toUpperCase() !== 'ESCAPE') return;

	    this.hidePanel();
	    this.elements.button.focus();
	  }

	  onItemClick(event) {
	    event.preventDefault();
	    const form = this.querySelector('form');
	    this.elements.input.value = event.currentTarget.dataset.value;
	    if (form) form.submit();
	  }

	  openSelector() {
	    this.elements.button.focus();
	    this.elements.panel.toggleAttribute('hidden');
	    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
	  }

	  closeSelector(event) {
	    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
	    if (event.relatedTarget === null || shouldClose) {
	      this.hidePanel();
	    }
	  }
	}
	customElements.define('localization-form', LocalizationForm);

	var isPaged = getParameterByName("page");

    if ( isPaged.length ){

	    console.log('isPaged', isPaged);
	    setTimeout(function(){
		    $("html, body").animate({
				scrollTop: body.offset().top
			}, 500);
		}, 500);

	}

	setTimeout(function(){
    	body.addClass('dom-loaded');
    }, 500);

    function getCookie(name) {
	    var cookieName = name + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var cookieArray = decodedCookie.split(';');
	    for(var i = 0; i < cookieArray.length; i++) {
	        var cookie = cookieArray[i].trim();
	        if (cookie.indexOf(cookieName) === 0) {
	            return cookie.substring(cookieName.length, cookie.length);
	        }
	    }
	    return "";
	}

	// Check if the "exampleCookie" has been set
	var checkVisitedCookie = getCookie("setVisitedCookie");
	if (checkVisitedCookie === "") {
		body.addClass('not-visited'); 	  
	}

    function setVisitedCookie(name, value, days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

    function setCookie(name, value, days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

	// Set a cookie named "exampleCookie" with value "exampleValue" that expires in 30 days
	setVisitedCookie("setVisitedCookie", "visited", 30);

    // GELOCATION MODAL CHECK
	if ( $('.gelocation-modal-outter').length ){
		var checkGelocationCookie = getCookie("setGelocationCookie");
		if (checkGelocationCookie === "") {
			// Run check on ISO
		}
		$(document).on('click', '.j-geolocation-modal-toggle', function(e) {
            e.preventDefault();
            $('.gelocation-modal-outter').fadeOut();
            setCookie("setGelocationCookie", "visited", 365);
        });
        $(document).on('click', '.gelocation-modal-outter .inner .list .item', function() {
        	setCookie("setGelocationCookie", "visited", 365);
            $('.gelocation-modal-outter').fadeOut();
        });
	}

    function watchForZenChatHash() {
        // Initial check if the hash is already in the URL when the page loads
        if (window.location.hash === '#zen-chat') {
            activateZenChat();
        }
        // Listen for hash changes
        $(window).on('hashchange', function() {
            if (window.location.hash === '#zen-chat') {
                activateZenChat();
            }
        });
    }
    function activateZenChat() {
    	zE(function() {
			zE('messenger', 'open');
		});
        console.log('Zen Chat Activated');
    }
    $(document).on('click', 'a[href="#zen-chat"]', function(e){
    	e.preventDefault();
    	activateZenChat();
    });
    // Call the function to start watching for the hash
    watchForZenChatHash();

});